import { TrackObj } from "../../pages/MyTracks/types";

export const getOnboardingTutorialStepsForDesktop = (
  tracks: TrackObj[]
): any => {
  return [
    {
      content: (
        <div>
          <h2>Welcome to OmMuse</h2>
          <h5>Let&#39;s show you around.</h5>
        </div>
      ),
      locale: { skip: <strong>SKIP</strong> },
      target: "body",
      placement: "center",
    },
    {
      content: <h5>Add a single or multiple tracks at a time.</h5>,
      target: "#step-1",
    },
    {
      content: (
        <h5>
          Use the filter bar to search by genre, artist, collaborators, or BPM.
          The sort dropdown lets your sort by date created, date modified,
          title, or artist.
        </h5>
      ),
      target: "#step-2",
    },
    {
      content: (
        <h5>Search through all your tracks, files, and other artists.</h5>
      ),
      target: "#step-3",
    },
    {
      content: (
        <h5>
          The page you are on now is your OmMuse Hub, upload and organize your
          tracks and their versions and files here.
        </h5>
      ),
      target: "#step-4",
    },
    {
      content: (
        <h5>
          If you want to upload and share individual files, like Ableton or Pro
          Tools sessions, use the Files tab. These files can also be added to a
          Track and shared with your collaborators.
        </h5>
      ),
      target: "#step-5",
    },
    {
      content: (
        <h5>
          Explore music from our featured artists and NFTs minted through
          OmMuse.
        </h5>
      ),
      target: "#step-6",
    },
    {
      content: <h5>Explore our featured Artists and OmMuse Community.</h5>,
      target: "#step-7",
    },
    {
      content: (
        <h5>
          Have a band? Invite them here. You can also invite them whenever you
          add a new track or file.
        </h5>
      ),
      target: "#step-8",
    },
    {
      content: <h5>Manage your profile and account</h5>,
      target: "#step-9",
    },
    {
      content: <h5>Create a Chat with your friends</h5>,
      target: "#step-10",
    },
    {
      content: (
        <div>
          <h5>
            {tracks.length === 0
              ? "Drag and drop your music, or use the Add Music button to upload your first track."
              : "Use the Add Music button to upload a single or multiple tracks. "}
          </h5>
          <p>
            After uploading your tracks you can upload new versions, share them
            with your collaborators or band, start chats for specific tracks,
            and even master using Dolby.io. Have fun!
          </p>
        </div>
      ),
      target: "body",
      placement: "center",
    },
  ];
};

export const getOnboardingTutorialStepsForSmallScreen = (
  tracks: TrackObj[]
): any => {
  return [
    {
      content: (
        <div>
          <h2>Welcome to OmMuse</h2>
          <h5>Let&#39;s show you around.</h5>
        </div>
      ),
      locale: { skip: <strong>SKIP</strong> },
      target: "body",
      placement: "center",
    },
    {
      content: (
        <h5>
          Explore our intuitive menubar to easily navigate through our offerings
          and find what you&#39;re looking for.
        </h5>
      ),
      target: "#small-screen-menu",
    },
    {
      content: (
        <h5>
          Use the filter bar to search by genre, artist, collaborators, or BPM.
          The sort dropdown lets your sort by date created, date modified,
          title, or artist.
        </h5>
      ),
      target: "#small-screen-search",
    },
    {
      content: <h5>Add a single or multiple tracks at a time.</h5>,
      target: "#step-1",
    },
    {
      content: (
        <h5>
          Use the filter bar to search by genre, artist, collaborators, or BPM.
          The sort dropdown lets your sort by date created, date modified,
          title, or artist.
        </h5>
      ),
      target: "#step-2",
    },
    {
      content: (
        <h5>Manage your profile and account by clicking your profile icon.</h5>
      ),
      target: "#step-9",
    },
    {
      content: <h5>Create a Chat with your friends</h5>,
      target: "#step-10",
    },
    {
      content: (
        <div>
          <h5>
            {tracks.length === 0
              ? "Drag and drop your music, or use the Add Music button to upload your first track."
              : "Use the Add Music button to upload a single or multiple tracks. "}
          </h5>
          <p>
            After uploading your tracks you can upload new versions, share them
            with your collaborators or band, start chats for specific tracks,
            and even master using Dolby.io. Have fun!
          </p>
        </div>
      ),
      target: "body",
      placement: "center",
    },
  ];
};
